import * as angular from 'angular';
import * as _ from 'lodash';

import { ObjectType } from '../../models/enum';
import { IValueViewModel } from '../../models/viewModels';
import { ComponentDefinition } from '../../models';
import { guidEmpty } from '../../common';
import { IStoreService } from '../../services';
import { StoreElement, Store } from '../../stateManagement';
import { Unsubscribe } from 'redux';

class ViewModelSelector implements angular.IComponentController {
    isLoading: boolean;
    isPopoverOpen: boolean;
    model: string;
    placeHolderText: string;
    selected: IValueViewModel; // from callers
    series: IValueViewModel[];
    viewModel: IValueViewModel;

    readonly filter: (value: { }) => IValueViewModel[];
    readonly formController: angular.IFormController;
    readonly initialSearch: string;
    readonly isRequired: boolean;
    readonly isSearchDisabled: boolean;
    readonly objectType: ObjectType;
    readonly onChange: (value: { }) => void;
    readonly placeHolder: string;
    readonly placement: string;
    readonly property: string;
    readonly selectedSerie: IValueViewModel; // from search component

    private _allSeries: IValueViewModel[];
    private _garbage: Unsubscribe;

    static $inject = [
        '$scope',
        '$timeout',
        'storeService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$timeout: angular.ITimeoutService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.placeHolderText = this.placeHolder;
        if (!this.placeHolderText) {
            this.placeHolderText = 'Click to select tag or identifier';
        }
        this._$scope.$watch(() => this.isPopoverOpen, (newValue) => {
            if (newValue) { // openning
                this.refreshSeriesFiltering();
            }
        });

        this._$scope.$watch(() => this.model, () => {
            this.selectVm(false);
        });

        this._$scope.$watch(() => this.selectedSerie, (newValue) => {
            if (newValue) {
                this.closePopover();
                this.model = newValue.guid;
                this.selectVm();
                if (this.formController) {
                    this.formController[this.property].$setDirty();
                }
                this.checkValidity();

                if (this.onChange) {
                    this.onChange({ value: this.model, viewModel: this.viewModel });
                }
            }
        });

        this.isLoading = true;

        this._garbage = this._storeService.register(
            store => this.refreshStore(store),
            [StoreElement.ValueViewModels]
        );
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        this._$timeout(() => {
            this.checkValidity();
        });
        if (changesObj['placeHolder']?.currentValue) {
            this.placeHolderText = this.placeHolder;
        }
    }

    $onDestroy() {
        if (this._garbage) {
            this._garbage();
        }
        this._allSeries = null;
    }

    closePopover() {
        this.isPopoverOpen = false;
    }

    private refreshStore(store: Store): void {
        this._allSeries = _.values(store.valueViewModels.dictionary);
        this.selectVm();
        this.isLoading = false;
    }

    private checkValidity() {
        if (!!this.isRequired
            && (!this.model || this.model === guidEmpty)
            && this.formController
            && this.formController[this.property]) {
            this.formController[this.property].$setValidity('required', false);
        }
    }

    private refreshSeriesFiltering(isFilter: boolean = true) {
        let vms = this._allSeries;
        // filter by type
        if (vms) {
            if (this.objectType !== undefined) {
                vms = vms.filter(vm => vm.objectType === this.objectType);
            }
            // business filter from caller
            this.series = this.filter && isFilter
                ? this.filter({ list: vms })
                : vms;
        }
    }

    private selectVm(isFilter: boolean = true) {
        this.refreshSeriesFiltering(isFilter);
        this.selected = _.find(this.series, v => v.guid === this.model);
        this.viewModel = this.selected;
    }
}

export const wtViewModelSelector: ComponentDefinition = {
    componentId: 'wtViewModelSelector',
    controller: ViewModelSelector,
    template: require('./viewModelSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        appendChild: '<?',
        contextClass: '@?',
        filter: '&?',
        formController: '<?',
        initialSearch: '@?',
        isRequired: '<?',
        isSearchDisabled: '<?',
        model: '=',
        objectType: '<?',
        onChange: '&?',
        placeHolder: '<?',
        placement: '@?',
        property: '@?',
        viewModel: '=?'
    }
};